export const getTimeZone = () => {
  const offset = new Date().getTimezoneOffset();
  return (0 - offset) / 60;
};

export const timeStringToHours = (timeString: string) => {
  const [h, m, s] = timeString.split(':').map(Number);
  return h + m / 60 + s / 3600;
};

export const hoursToTimeString = (hours: number, withSeconds = true) => {
  const h = Math.floor(hours);
  const minutes = (hours - h) * 60;
  const m = Math.floor(minutes);
  const seconds = (minutes - m) * 60;
  const s = Math.floor(seconds);
  if (!withSeconds) {
    return [h, m].map((i) => String(i).padStart(2, '0')).join(':');
  }
  return [h, m, s].map((i) => String(i).padStart(2, '0')).join(':');
};

export const convertTimeStringToLocalTZ = (
  timeString: string,
  tz = getTimeZone(),
) => {
  let hours = timeStringToHours(timeString);
  hours += tz;
  return hoursToTimeString(hours);
};

export default {
  getTimeZone,
};
